import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { format } from 'date-fns';
import api from 'api';
import Util from 'utility';
import { __ } from 'locale';

import PanelAddFood from './PanelAddFood';
import PanelAddRecipe from './PanelAddRecipe';
import PanelAddFoodGroup from './PanelAddFoodGroup';
import PanelRecipeSettings from './PanelRecipeSettings';
import PanelSave from './PanelSave';

import { openModal, closeModal, setRecipeTitle, setPlannerEditMode } from 'actions/index';

function MenuPanelHorizontal({ action, parameters }) {
    const data = useSelector(state => state);
    const dispatch = useDispatch();
    const history = useHistory();
    const { id: routeId } = useParams();

    // Is this a drink regime meal type?
    let isDrinkRegime = false;
    let hash = parameters?.hash;
    if (hash && typeof hash === 'string') {
        hash = hash.split('_')[0];
        isDrinkRegime = data.globals.mealTypes[hash]?.is_drink_regime;
    }

    useEffect(() => {
        window.globalBroadcaster.subscribe('openAddFoodPanel', openPanelAddFood);
        window.globalBroadcaster.subscribe('openAddRecipePanel', openPanelAddRecipe);
        return () => {
            window.globalBroadcaster.unsubscribe('openAddFoodPanel');
            window.globalBroadcaster.unsubscribe('openAddRecipePanel');
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const openPanelAddFood = (e) => {
        if (e) { e.preventDefault(); if (e.target !== e.currentTarget) return; }
        dispatch(closeModal());
        dispatch(openModal({
            title: 'Přidat potravinu',
            class: 'dialog-big',
            content: <PanelAddFood onFoodAdded={() => dispatch(closeModal())} isDrinkRegime={isDrinkRegime} />
        }));
    };

    const openPanelAddRecipe = (e) => {
        if (e) { e.preventDefault(); if (e.target !== e.currentTarget) return; }
        let isGastroDailyMenu = false;
        if (typeof data.meals[data.activeMealHash] === 'object') {
            const mealId = data.meals[data.activeMealHash].mealId;
            isGastroDailyMenu = data.globals.mealTypes[mealId].gastro_only;
        }
        dispatch(closeModal());
        dispatch(openModal({
            title: __('Přidat recept'),
            class: 'dialog-big',
            content: <PanelAddRecipe onRecipeAdded={() => dispatch(closeModal())} isGastroDailyMenu={isGastroDailyMenu} isDrinkRegime={isDrinkRegime} />
        }));
    };

    const openPanelAddFoodGroup = (e) => {
        e.preventDefault();
        if (e.target !== e.currentTarget) return;
        dispatch(closeModal());
        dispatch(openModal({
            title: 'Přidat talíř',
            content: <PanelAddFoodGroup onFoodGroupAdded={() => dispatch(closeModal())} />
        }));
    };

    const openPanelRecipeSettings = (e) => {
        e.preventDefault();
        if (e.target !== e.currentTarget) return;
        dispatch(closeModal());
        dispatch(openModal({
            title: __('Postup přípravy receptu'),
            class: 'dialog-flexible',
            closeButton: __('Uložit a zavřít'),
            content: <PanelRecipeSettings />
        }));
    };

    const openPanelSave = (e) => {
        e.preventDefault();
        if (e.target !== e.currentTarget) return;
        const currentRecipeId = routeId !== 'undefined' ? routeId : 0;
        dispatch(closeModal());
        dispatch(openModal({
            title: __('Uložit recept'),
            class: 'dialog-big',
            content: <PanelSave currentRecipeId={currentRecipeId} onSaved={() => dispatch(closeModal())} />
        }));
    };

    const saveAndBackToPlanner = () => {
        const mh = data.activeMealHash;
        if (data.titles[mh] === '') {
            for (const g in data.foodGroups[mh]) {
                if (data.titles[mh] === '') data.titles[mh] = data.foodGroups[mh][g].title;
            }
        }

        let dateParsed = data.plannerDate;
        if (Util.isLectureLikeMode(data.appMode)) dateParsed = new Date('2000-01-01');

        const dateUTC = new Date(Date.UTC(
            dateParsed.getFullYear(), dateParsed.getMonth(), dateParsed.getDate(),
            dateParsed.getHours(), dateParsed.getMinutes(), dateParsed.getSeconds()
        ));
        const dayTimestamp = Math.floor(dateUTC.getTime() / 1000);

        const saveData = JSON.stringify({
            meals: JSON.stringify(data.meals),
            groups: JSON.stringify(data.foodGroups),
            foods: JSON.stringify(data.foods),
            modifications: JSON.stringify(data.modifications),
            titles: JSON.stringify(data.titles),
            desciptions: JSON.stringify(data.desciptions),
            activities: JSON.stringify(data.activities),
            trainings: JSON.stringify(data.trainings),
            dayTimestamp: JSON.stringify(dayTimestamp),
            energyOutputSettings: JSON.stringify(data.energyOutputSettings)
        });

        api('save/dayplan', { post: true, data: saveData }).then(() => {
            if (Util.isLectureLikeMode(data.appMode)) {
                history.push('/plan');
            } else {
                history.push('/plan/' + format(data.plannerDate, 'yyyy-MM-dd'));
            }
        });
    };

    const mh = data.activeMealHash;
    const recipeName = typeof data.titles[mh] !== 'undefined' ? data.titles[mh] : '';
    const saveButtonStyle = data.unsavedRecipe === true ? { background: '#f00', color: '#fff' } : {};

    const baseButtons = (
        <>
            <a onClick={openPanelAddRecipe}><i className="fa fa-plus"></i> Recept</a>
            <a onClick={openPanelAddFoodGroup}><i className="fa fa-plus"></i> Talíř</a>
            <a onClick={openPanelRecipeSettings}><i className="fa fa-book"></i> Postup přípravy</a>
        </>
    );

    let dynamicButtons = null;
    let headingContent = null;

    switch (action) {
        case undefined:
        case 'recipe-new':
            dynamicButtons = <a style={saveButtonStyle} onClick={openPanelSave}><i className="fa fa-save"></i> Uložit</a>;
            break;
        case 'recipe-edit':
            dynamicButtons = <a onClick={openPanelSave}><i className="fa fa-save"></i> Uložit</a>;
            break;
        case 'meal-edit':
            if (typeof data.meals[mh] === 'undefined') {
                history.push('/plan/' + format(new Date(), 'yyyy-MM-dd'));
            } else {
                const sh = String(data.meals[mh].startHour).padStart(2, '0');
                const sm = String(data.meals[mh].startMinute).padStart(2, '0');
                headingContent = <>{data.globals.mealTypes[data.meals[mh].mealId].title}<small>{format(data.plannerDate, 'dd.MM.yyyy')}, {sh}:{sm}</small></>;
                dynamicButtons = (
                    <>
                        <a onClick={openPanelSave}><i className="fa fa-save"></i> Uložit do mých receptů</a>
                        <a onClick={saveAndBackToPlanner}><i className="fa fa-save"></i> Uložit a zpět do Plánovače</a>
                    </>
                );
            }
            break;
        case 'cookbook-edit':
            dynamicButtons = <a onClick={openPanelSave}><i className="fa fa-save"></i> Uložit do mých receptů</a>;
            break;
        case 'lecture-task':
            if (typeof data.meals[mh] === 'undefined') {
                history.push('/plan');
            } else {
                const sh = String(data.meals[mh].startHour).padStart(2, '0');
                const sm = String(data.meals[mh].startMinute).padStart(2, '0');
                headingContent = <>{data.globals.mealTypes[data.meals[mh].mealId].title}<small>{sh}:{sm}</small></>;
                dynamicButtons = (
                    <>
                        <a onClick={openPanelSave}><i className="fa fa-save"></i> Uložit do mých receptů</a>
                        <a style={{background:'#e40'}} onClick={saveAndBackToPlanner}><i className="fa fa-save"></i> Uložit a zpět na přehled</a>
                    </>
                );
            }
            break;
        case 'recipe-editor':
            if (!baseButtons && !dynamicButtons) return null;
            break;
    }

    if (!baseButtons && !dynamicButtons) return null;

    let buttons = (
        <>
            {baseButtons}
            {dynamicButtons}
        </>
    );

    // GASTRO: Editing daily menu?
    if (action === 'meal-edit' && typeof data.meals[mh] === 'object') {
        if (data.globals.mealTypes[data.meals[mh].mealId].gastro_only === true) {
            buttons = (
                <>
                    <a onClick={openPanelAddRecipe}><i className="fa fa-plus"></i> {__('Přidat recept')}</a>
                    <a onClick={saveAndBackToPlanner}><i className="fa fa-save"></i> Uložit a zpět do Plánovače</a>
                </>
            );
        }
    }

    return (
        <div className="text-center bg-[#eff1f7] relative" style={{padding:'.5em 0'}}>
            <div className="max-w-[1180px] mx-auto px-[1em]">
                <div className="flex items-center py-[1.5rem]">
                    <h1>{headingContent}</h1>
                    <aside className="ml-auto flex items-center">
                        <label className="hidden max-[959px]:inline-block cursor-pointer" htmlFor="cb-page-header-nav"><i className="fa fa-angle-down"></i></label>
                        <input className="peer hidden" type="checkbox" id="cb-page-header-nav" />
                        <div className="block max-[959px]:hidden max-[959px]:peer-checked:block max-[959px]:peer-checked:absolute max-[959px]:peer-checked:right-[1em] max-[959px]:peer-checked:top-[calc(100%-0.65rem)] max-[959px]:peer-checked:z-[110] max-[959px]:peer-checked:bg-white max-[959px]:peer-checked:shadow-[0_12px_40px_rgba(0,0,0,0.3)] max-[959px]:peer-checked:px-[0.5em] max-[959px]:peer-checked:w-full max-[959px]:peer-checked:max-w-[260px]">
                            {buttons}
                        </div>
                    </aside>
                </div>
            </div>
        </div>
    );
}

export default MenuPanelHorizontal;
